import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Star, Users, FileText, CheckCircle } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-0 md:min-h-screen flex flex-col items-center pt-4 pb-10 md:pt-8 md:pb-20 px-4 overflow-hidden" data-id="element-50">
      {/* Background decorative elements */}
      <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-mystic-700 rounded-full mix-blend-screen filter blur-[100px] opacity-50" data-id="element-51"></div>
      <div className="absolute bottom-[10%] right-[-10%] w-96 h-96 bg-gold-dark rounded-full mix-blend-screen filter blur-[120px] opacity-20" data-id="element-52"></div>

      {/* Top Bar - Small label */}
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-4xl mx-auto text-center mb-4 md:mb-6" data-id="element-53">
        <p className="text-gold-light font-medium tracking-widest uppercase text-[10px] md:text-[12px]" data-id="element-54">
          Informes profesionales para facilitadoras
        </p>
      </motion.div>

      <div className="max-w-6xl mx-auto w-full flex flex-col items-center text-center z-10" data-id="element-55">
        {/* Main Title */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="max-w-4xl mx-auto mb-6 md:mb-10" data-id="element-56">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-white leading-tight mb-0" data-id="element-57">
            ✨ Dejá de perder horas preparando lecturas desde cero.
          </h1>
        </motion.div>

        {/* Mockup Image - Now between title and subtitle */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.8
      }} className="w-full max-w-4xl mx-auto mb-6 md:mb-10 relative" data-id="element-58">
          <div className="absolute inset-0 bg-gold-light/10 filter blur-[80px] rounded-full transform scale-75" data-id="element-59"></div>
          <img src="https://cdn.magicpatterns.com/uploads/tMvGUeneUkRwipK2X1GkJF/heylloyd-image-1775883769683-Photoroom.png" alt="Sistema Pro Registros Akáshicos Mockup" className="w-[60%] md:w-[80%] mx-auto h-auto relative z-10 drop-shadow-2xl" data-id="element-60" />
        </motion.div>

        {/* Subtitle + CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="max-w-2xl mx-auto mb-8 md:mb-16" data-id="element-61">
          <p className="text-base md:text-xl text-gray-300 leading-relaxed mb-6 md:mb-10" data-id="element-62">
            Sistema completo de lecturas akáshicas profesionales listas para
            entregar. Todo tu flujo de trabajo resuelto en un clic.
          </p>

          <Button onClick={scrollToPricing} className="text-lg md:text-xl px-6 py-4 md:px-10 md:py-5" data-id="element-63">
            ¡QUIERO EL SISTEMA AHORA!
          </Button>
        </motion.div>

        {/* Social Proof Strip */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="w-full max-w-5xl mx-auto" data-id="element-64">
          <p className="text-gray-400 text-xs md:text-sm uppercase tracking-widest mb-4 md:mb-6" data-id="element-65">
            Respaldado por +1.000 Facilitadoras profesionales
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-8" data-id="element-66">
            <div className="glass-card p-3 md:p-4 rounded-2xl flex flex-col items-center justify-center text-center" data-id="element-67">
              <Users className="w-5 h-5 md:w-6 md:h-6 text-gold mb-1 md:mb-2" data-id="element-68" />
              <span className="font-bold text-base md:text-lg text-white" data-id="element-69">
                +1.000
              </span>
              <span className="text-[10px] md:text-xs text-gray-400" data-id="element-70">
                Profesionales
              </span>
            </div>
            <div className="glass-card p-3 md:p-4 rounded-2xl flex flex-col items-center justify-center text-center" data-id="element-71">
              <Star className="w-5 h-5 md:w-6 md:h-6 text-gold mb-1 md:mb-2" data-id="element-72" />
              <span className="font-bold text-base md:text-lg text-white" data-id="element-73">
                9.8/10
              </span>
              <span className="text-[10px] md:text-xs text-gray-400" data-id="element-74">
                Calificación
              </span>
            </div>
            <div className="glass-card p-3 md:p-4 rounded-2xl flex flex-col items-center justify-center text-center" data-id="element-75">
              <FileText className="w-5 h-5 md:w-6 md:h-6 text-gold mb-1 md:mb-2" data-id="element-76" />
              <span className="font-bold text-base md:text-lg text-white" data-id="element-77">
                +335 Páginas
              </span>
              <span className="text-[10px] md:text-xs text-gray-400" data-id="element-78">
                Recursos Completos
              </span>
            </div>
            <div className="glass-card p-3 md:p-4 rounded-2xl flex flex-col items-center justify-center text-center" data-id="element-79">
              <CheckCircle className="w-5 h-5 md:w-6 md:h-6 text-gold mb-1 md:mb-2" data-id="element-80" />
              <span className="font-bold text-base md:text-lg text-white" data-id="element-81">
                100% Probado
              </span>
              <span className="text-[10px] md:text-xs text-gray-400" data-id="element-82">
                Método Exacto
              </span>
            </div>
          </div>

          <div className="mt-6 md:mt-12 inline-block border-b border-gold/30 pb-2" data-id="element-83">
            <h3 className="md:text-2xl font-serif text-gold-light italic text-[14px]" data-id="element-84">
              Para Facilitadoras de Registros Akáshicos Profesionales
            </h3>
          </div>
        </motion.div>
      </div>
    </section>;
}